import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import RootLayout from 'layouts/RootLayout';
import Breadcrumbs from 'components/Breadcrumbs';
import proxyAxios from 'api/proxyAxios';
import { endpoints } from 'api/endpoints';
import { Post } from 'sections/Resources/FreightDictionary/Posts';
import { CountriesData } from 'sections/Resources/FreightForwarder/data';
import { withSessionSsr } from 'lib/withSession';

const Head = dynamic(() => import('sections/Resources/FreightForwarder/Head'));
const Countries = dynamic(() => import('sections/Resources/FreightForwarder/Countries'));
const SignUp = dynamic(() => import('sections/Resources/FreightDictionary/SignUp'));
const Posts = dynamic(() => import('sections/Resources/FreightDictionary/Posts'));

type FreightForwarderProps = {
  articles: Post[];
}

export default function FreightForwarderPage({ articles }: FreightForwarderProps) {
  return (
    <div className="freight-forwarder">
      <div className="container">
        <Breadcrumbs mTop={64} mode="light" links={[{ title: 'Freight Forwarder', href: '' }]} />
      </div>
      <Head/>
      <Countries/>
      <SignUp/>
      <Posts articles={articles}/>
    </div>
  );
}

export const getServerSideProps = withSessionSsr(async function ({ req, res }) {
  const { user } = req.session;

  const pageProps: any = {
    title: 'How to Become a Freight Forwarder | DF Alliance',
    description:
      'Get a step-by-step guide with DF Alliance to become a freight forwarder. Get all the basic information, license requirements, and instructions.',
    keywords: 'How to become a freight forwarder',
    path: '/freight-forwarder',
    countriesData: CountriesData,
    user: user === undefined ? 'no-user' : 'user'
  }

  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3&order=random');
    return {
      props:
        {
          articles,
          ...pageProps,
        }
    };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }

  return {
    props: {
      articles: [],
      ...pageProps,
    }
  }
});

FreightForwarderPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
